/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import './LeaveHistoryViewModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';

import { fonts, themes } from '../../../themes/themes';
import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import CardContentTile from '../../../components/CardContentTile/CardContentTile';
import VerticalBarController from '../../../components/VerticalBar/VerticalBarController';
import { baseDateFormatting } from '../../../helper';
import moment from 'moment';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  leaveHistoryViewData: any;
  trans?: any;
}

const AboutMeModalPresenter = ({
  isModalOpen,
  closeModal,
  leaveHistoryViewData,
  trans,
}: ModalProps) => {
  const handleSubmit = () => {
    closeModal();
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="755px"
      modalWidth="auto"
    >
      <ModalHeader
        modal={{ modal_title: trans('Leave Details') }}
        closeModal={closeModal}
      />
      <Grid
        container
        spacing={1}
        style={{
          marginTop: '35px',
        }}
      >
        <Grid item xs={8} className="left-grid_history">
          <Grid container style={{ padding: '10px' }}>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.blackDefault,
                  fontWeight: 'bold',
                }}
              >
                {trans('Leave Details')}
              </Typography>
            </Grid>

            <CardContentTile
              tile_key={trans('Leave Type')}
              tile_value={leaveHistoryViewData.leave_type.name}
            />
            <CardContentTile
              tile_key={trans('Leave Frequency')}
              tile_value={
                leaveHistoryViewData?.day_freq == 1
                  ? trans('Full Day')
                  : trans('Half Day')
              }
            />
            <CardContentTile
              tile_key={trans('Start Date')}
              tile_value={moment(leaveHistoryViewData?.start_date).format(
                baseDateFormatting,
              )}
            />
            <CardContentTile
              tile_key={trans('End Date')}
              tile_value={moment(leaveHistoryViewData?.end_date).format(
                baseDateFormatting,
              )}
            />
            <CardContentTile
              tile_key={trans('Reason')}
              tile_value={leaveHistoryViewData?.leave_reason}
            />
          </Grid>
          {leaveHistoryViewData?.attachment && (
            <Grid container style={{ padding: '10px' }}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.title,
                    color: themes.blackDefault,
                    fontWeight: 'bold',
                  }}
                >
                  {trans('Attachments')}
                </Typography>
              </Grid>
              <Box style={{ marginTop: '35px' }} />
              <DropAndSelect
                src={
                  leaveHistoryViewData?.attachment
                    ? leaveHistoryViewData?.attachment
                    : ''
                }
                disabledDeleteBtn={true}
                isAttachmentSigned={true}
              />
            </Grid>
          )}
        </Grid>
        <Grid item xs={1}></Grid>
        <Grid item xs={3} className="right-grid_history">
          <Grid container>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.blackDefault,
                  fontWeight: 'bold',
                  padding: '10px',
                }}
              >
                {trans('Tracking Details')}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                marginTop: '10px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <VerticalBarController
                instanceId={leaveHistoryViewData?.workflow_instance?.id}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
        isSubmitButton={false}
      />
    </CustomModal>
  );
};

export default AboutMeModalPresenter;
